import { FilterGroupName } from 'results/constants'

export const getFilterSectionDefaultExpanded = (
  groupName: string,
  variant: 'sidebar' | 'drawer'
): boolean => {
  if (variant === 'drawer') {
    return false
  }

  return (
    groupName === FilterGroupName.BRANDS ||
    groupName === FilterGroupName.PART_TYPE
  )
}
